import { useEffect, useState } from 'react';
import MobileNav from '../components/MobileNav';
import { GoPencil } from "react-icons/go";
import { FaPlay } from "react-icons/fa";
import { FaRankingStar } from "react-icons/fa6";
import { useNavigate, Link } from 'react-router-dom';
import { BsCamera } from "react-icons/bs";
import Footer from '../components/Footer';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import ChangePassword from '../components/ChangePassword';
import RecoveryEmail from '../components/RecoveryEmail';
import Feedback from '../components/Feedback';
import Query from '../components/Query';
import { BiHome } from "react-icons/bi";
import Status from '../components/Status';
import { API, resolveBackendPath } from '../config';


const Profile = () => {

      const defAvatar = '/assets/images/def_avatar.jpg';
    
      function resolveAvatar(src) {
        return resolveBackendPath(src, defAvatar);
      }

    const navigate = useNavigate();

    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [newUsername, setNewUsername] = useState('');
    const [showPwdModal, setShowPwdModal] = useState(false);
    const [showRecoveryEmail, setShowRecoveryEmail] = useState(false);
    const [isFeedbackOpen, setFeedbackOpen] = useState(false);
    const [isQueryOpen, setQueryOpen] = useState(false);
    const toggleFeedback = () => setFeedbackOpen(open => !open);
    const toggleQuery = () => setQueryOpen(open => !open);

    const [isStartingGame, setIsStartingGame] = useState(false);


    const token = localStorage.getItem('authToken');




    useEffect(() => {
        const fetchMe = async () => {
        try {
            const res = await fetch(`${API}/api/users/me`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` }
            });
            const data = await res.json();
            setProfile(data);
        } catch (err) {
            console.error('Failed to load profile', err);
        } finally {
            setLoading(false);
        }
        };
        fetchMe();
    }, []);




    if (loading) return <Status state="loading" title="Loading profile." note="Adding extra awesome…" />;

    if (!profile) return (
        <Status
            state="error"
            title="Couldn’t load profile"
            note="Please check your connection and try again."
            action={<Link to="/home" className="btn btn-primary">Go Home</Link>}
        />
    );

    const { avatar, username, latestScore, highestScore } = profile;

    //console.log('Profile data:', profile); // Debugging line

    const handleFile = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(true);
        const form = new FormData();
        form.append('avatar', file);

        const res = await fetch(`${API}/api/users/avatar`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
            body: form,
        });

        const data = await res.json();
        setProfile(prev => ({ ...prev, avatar: data.avatar }));  // update state
        setUploading(false);
    };

    
    const handleSinglePlayer = async () => {
        setIsStartingGame(true);
        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.post(
                `${API}/api/game/start-single-player`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            navigate(`/game/${response.data.roomId}`);
        } catch (error) {
            console.error('Error starting single-player game:', error);
        } finally {
            setIsStartingGame(false);
        }
    };

    const handleMultiplayer = () => {
        navigate('/lobby1');
    };


    const submitUsername = async (e) => {
        e.preventDefault();

        if (newUsername.length > 11) {
            return toast.error('Nickname must be fewer than 12 characters.');
        }

        if (newUsername.length < 2) {
            return toast.error('Nickname must be at least 2 characters.');
        }

        if (newUsername.trim().toLowerCase() === 'bigfoot') {
            return toast.error("Nice try... but Bigfoot is already taken. He's kind of a big deal around here.");
        }

        try {
            const res = await axios.patch(
                `${API}/api/users/me/username`,
                { username: newUsername.trim() },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setProfile(p => ({
                ...p,
                username: res.data.username,
                lastUsernameChange: res.data.lastUsernameChange
            }));
            setEditing(false);
            toast.success('Nickname updated!');
        } catch (err) {
            toast.error(err.response?.data?.error || 'Update failed');
        }
    };



    return (
       <>
            <section className="profile">

                {isFeedbackOpen && <Feedback onClose={toggleFeedback} />}
                {isQueryOpen && <Query onClose={toggleQuery} />}

                <Link to="/home" className='left-icon-link'>
                    <BiHome className='icon' />
                </Link>

                <MobileNav />

                <div className="profile-content">
                    <div className="profile-pic">
                        <img 
                            src={resolveAvatar(avatar)}
                            onError={(e) => { e.currentTarget.src = defAvatar; }}
                            alt={username} 
                        />
                        <div className="edit-icon"  onClick={() => document.getElementById('avatarInput').click()}>
                            <BsCamera className='camera-icon'/>
                        </div>
                        <input
                            type="file"
                            accept="image/*"
                            id="avatarInput"
                            style={{ display: 'none' }}
                            onChange={handleFile}
                        />
                        {uploading && <p className='uploading-text'>Updating avatar…</p>}
                    </div>

                    <div className={`nickname-div${editing ? ' editing' : ''}`}>
                        {editing ? (
                            <form onSubmit={submitUsername} className='username-form'>
                                <input
                                    value={newUsername}
                                    onChange={e => setNewUsername(e.target.value)}
                                    maxLength={20}
                                    className='username-input'
                                    autoFocus
                                />
                                <button type="submit" className='icon-btns submit-btn'><FaCheck /></button>
                                <button type="button" onClick={() => setEditing(false)} className='icon-btns cancel-btn'>
                                    <IoClose />
                                </button>
                            </form>
                        ) : (
                            <>
                                <p className="nickname">{profile.username}</p>
                                <GoPencil
                                    className='icon'
                                    onClick={() => {
                                        setNewUsername(profile.username);
                                        setEditing(true);
                                    }}
                                />
                            </>
                        )}
                    </div>

                    <div className="scores-div">
                        <div className="score latest">
                            <p>Latest Score</p>
                            <p>{latestScore}</p>
                        </div>
                        <div className="score highest">
                            <p>Highest Score</p>
                            <p>{highestScore}</p>
                        </div>
                    </div>

                    <button className='btn quick-play-btn' onClick={handleSinglePlayer}>
                        <span>{ isStartingGame ? 'Starting game...' : 'Play Now'}</span>
                        <FaPlay className='icon' />
                    </button>

                    <button className='btn multiplayer-btn' onClick={handleMultiplayer}>
                        <span>Multiplayer</span>
                        <FaPlay className='icon' />
                    </button>

                    <button className='btn leaderboard-btn' onClick={() => navigate('/leaderboard')}>
                        <span>Leaderboard</span>
                        <FaRankingStar className="icon"/>
                    </button>
                </div>
                <div className="quick-CTAs">
                    <p className="opens-modal change-pwd-cta" onClick={() => setShowPwdModal(true)}>Change your password</p>
                    <p className="opens-modal change-pwd-cta" onClick={() => setShowRecoveryEmail(true)}>Set recovery email</p>
                </div>


                <Footer onOpenFeedback={toggleFeedback} onOpenQuery={toggleQuery}/>
            </section>  
            
            <ChangePassword
                show={showPwdModal}
                onClose={() => setShowPwdModal(false)}
                token={token}
            />

            <RecoveryEmail
                show={showRecoveryEmail}
                onClose={() => setShowRecoveryEmail(false)}
                token={token}
            />

            <ToastContainer position="top-right" autoClose={3000} />
            
       </>
    );
};

export default Profile;
